module.exports = __webpack_public_path__ + "static/media/alert-icon.65405630.svg";